// extracted by mini-css-extract-plugin
export default {"root":"PromptPanel_root__OS1yM","header":"PromptPanel_header__zqDSD","modelName":"PromptPanel_modelName__hUv4H"};